import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
  flex-shrink: 0;
}`],
})
export class ComponentNavSidebarComponent implements OnInit {
    public menus: any[] = [];
    public dashboardLink: string = '/admin';
    public collapsed: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const saved = localStorage.getItem('sidebar-collapsed');
        this.collapsed = saved === 'true';
        this.buildMenus();
        await this.service.render();
    }

    public toggleCollapse() {
        this.collapsed = !this.collapsed;
        localStorage.setItem('sidebar-collapsed', String(this.collapsed));
        this.service.render();
    }

    public getMenuClass(link: string): string {
        const active = this.isActive(link);
        const base = this.collapsed ? 'px-0 py-2.5 justify-center' : 'px-3 py-2.5';
        if (active) return base + ' text-zinc-900 bg-indigo-50';
        return base + ' text-zinc-500 hover:text-zinc-700 hover:bg-zinc-50';
    }

    private buildMenus() {
        const role = this.service.auth.session?.role || 'user';
        this.dashboardLink = role === 'admin' ? '/admin' : '/user';

        const allMenus = [
            {
                group: 'OVERVIEW',
                items: [
                    { label: '대시보드', icon: 'fa fa-th-large', link: this.dashboardLink, roles: ['admin', 'user'] },
                ],
            },
            {
                group: 'DATA MANAGEMENT',
                items: [
                    { label: '컬렉션', icon: 'fa fa-database', link: '/collections', roles: ['admin'] },
                    { label: 'Fine Tuning', icon: 'fa fa-bolt', link: '/dataset/finetune', roles: ['admin'] },
                    { label: 'Instruction Tuning', icon: 'fa fa-book', link: '/dataset/instruction', roles: ['admin'] },
                ],
            },
            {
                group: 'QA 검수',
                items: [
                    { label: 'QA 검수', icon: 'fa fa-clipboard-check', link: '/review', roles: ['user'] },
                ],
            },
            {
                group: 'SYSTEM',
                items: [
                    { label: '사용자 관리', icon: 'fa fa-users-cog', link: '/members', roles: ['admin'] },
                ],
            },
            {
                group: 'ACCOUNT',
                items: [
                    { label: '마이페이지', icon: 'fa fa-user-circle', link: '/mypage', roles: ['user'] },
                ],
            },
        ];

        this.menus = allMenus
            .map(group => ({
                ...group,
                items: group.items.filter(item => item.roles.includes(role)),
            }))
            .filter(group => group.items.length > 0);
    }

    public isActive(link: string): boolean {
        const current = window.location.pathname;
        return current === link || current.startsWith(link + '/');
    }

    public navigate(link: string) {
        this.service.href(link);
    }

    public logout() {
        location.href = '/auth/logout?returnTo=/access';
    }

    public get userName(): string {
        return this.service.auth.session?.name || '사용자';
    }

    public get userRole(): string {
        const role = this.service.auth.session?.role || '';
        const map: any = { admin: '관리자', expert: '전문가', user: '사용자' };
        return map[role] || role;
    }

    public get userInitial(): string {
        const name = this.service.auth.session?.name || '?';
        return name[0];
    }

    public get userEmail(): string {
        return this.service.auth.session?.email || '';
    }
}

export default ComponentNavSidebarComponent;